
import React, { Component } from 'react';
import './recommandation-report.scss'
import { Modal, ModalBody } from "reactstrap";
import HomeworkApi from '../../../apis/homework'
import TestApi from '../../../apis/test'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';
import Latex from "react-latex";
import { InlineMath, BlockMath } from 'react-katex'
import MathJax from "react-mathjax2"
import CwContentViewer from '../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../common/canvas/canvas'
import GeometryTranspiler from '../../common/geometry/geometry-parser'
import { element } from 'prop-types';
import Path from '../../routes/routes-path';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import CwConfirm from '../../common/cw-confirmation-modal/cw-confirmation-modal'
import ReactTooltip from 'react-tooltip';
import SolvedExamples from '../../learning-resources/solved-examples/solved-examples';
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2';
// import Question from '../../common/question-view-answers/question/question';
// import WronglyAnsweredUsers from './wrongly-answered-users/wrongly-answered-users';
import { jsPDF } from "jspdf";
import SchoolApi from '../../../apis/school';
import PublicComponent from './public-component/public-component';



class AddContactComponent extends Component {


    selectedItem = {
    }

    skillList = [
        {
            type: "KNOWLEDGE",
            title: "KNOWLEDGE - Ability to remember formulas",
            image: ImageConstants.KNOWLEDGE,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "CALCULATION",
            title: "CALCULATION - Ability to Calculate",
            image: ImageConstants.CALCULATION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "MODELING",
            title: "MODELING - Ability to get Logic & form equation",
            image: ImageConstants.MODELING,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "COMPREHENSION",
            title: "COMPREHENSION - Ability to Understand the Language",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        }]

    orderedSkills = ["knowledge", "calculation", "modeling", "comprehension"]

    tab = [
        { title: "What are the Learning Gaps", subTitle: '(based on Most Wrong Questions)', value: 2, color: "#FFDEF8", image: 'MEN_BULB_BLUE' },
        { title: "How to Remedy the Learning Gaps", subTitle: "(based on Most Wrong Questions)", value: 1, color: "#E1F4FF", image: "Q_A_CIRCLE" },
        { title: "Recommended Action", subTitle: '', value: 3, color: "#D5FFE7", image: "RECOMMENDED_ACTION" }
    ]


    constructor(props) {
        super(props)

        console.log(this.props.selectedItem)

        if (!this.props.selectedStatus) {
            this.selectedItem = {
                class: this.props.selectedItem.class,
                section: this.props.selectedItem.section,
                chapterName: this.props.selectedItem.chapter,
                createdDate: this.props.selectedItem.createdDateTimestamp,
                _id: this.props.selectedItem._id,
                type: this.props.selectedItem?.type || ''
            }
        } else if (this.props.selectedStatus) {
            this.selectedItem = {
                class: this.props.selectedItem.class,
                section: this.props.selectedItem.section,
                chapterName: this.props.selectedItem.chapters ? this.props.selectedItem.chapters : this.props.selectedItem.chapter,
                createdDate: this.props.selectedItem.createdDateTimestamp,
                _id: this.props.selectedItem._id
            }

            console.log(this.selectedItem)
        }


    }

    state = {
        setPublicData: false,
        showOptions: true,
        showReport: [],
        selectedTabIndex: -1,

        wrongAnswers: [],
        wrongAnswersOfallUsers: [],
        availabelFiltersHash: {},
        selectedIndex: 1,
        selectedPercentage: 0,
        reload: true,
        topFiveWrongAnsweredQuestions: [],
        showVideoList: [],
        pdfReportDownloadLink: '',
        topWrongPercentage: 0,
        contentIds: [],
        eloReport: [],


        homeworkAssignPayload: {
            chapterTitle: this.props.selectedItem.chapter,
            chapterKey: this.props.selectedItem.conceptBuild[0].chapterKey,
            selectedClass: this.props.selectedItem.class,
            selectedBoard: this.props.selectedItem.board,
            conceptKey: this.props.selectedItem.conceptBuild,
            homeworkId: this.props.selectedItem._id,
            // selectedConceptName: concept.title,
            // masterDataId: this.props.masterDataId,
            from: "RECOMMANDATION_REPORT"
        },

        noviceUsers: [
        ],
        types: [
            {
                title: "Novice",
                threshold: "< 50%",
                color: "#8B8BF6",
                mark: "30%" //for demo only
            },
            {
                title: "Proficient",
                threshold: "50%-80%",
                color: "#FFBB7C",
                mark: "60%"
            },
            {
                title: "Advance",
                threshold: "> 80%",
                color: "#80D2F4",
                mark: "90%"
            }
        ]
    }

    componentDidMount() {
        console.log(this.state.homeworkAssignPayload)
        if (this.props.selectedStatus) {
            this.getStatusWiseWrongAnswers()
        } else {
            this.getWrongAnswers();
        }

        this.getEloReport()
        this.getHomeworkEvaluationReport()
        // this.generatePdf()

    }

    generatePdf(conceptWiseTopFiveNotClearedElo) {
        //console.log(conceptWiseTopFiveNotClearedElo)


        let notClearedEloIds = [], eloNotClearedStudentPercentageHashByEloId = {}

        conceptWiseTopFiveNotClearedElo.forEach(elo => {
            // if (elo.skill == "modelling") elo.skill = "modeling"
            // let skills = elo.skill
            // for (let index = 0; index < this.orderedSkills.length; index++) {
            //     let key = this.orderedSkills[index]
            //     let skillDetails = skills[key]

            //     if (!skillDetails) continue

            //     if (skillDetails && skillDetails.length) {

            //         skillDetails.map(item => {
            notClearedEloIds.push(elo.eloId)
            eloNotClearedStudentPercentageHashByEloId[elo.eloId] = `${this.calculatePercentage(elo.incorrect, this.state.totalUsers) || 0}%`
            //         })

            //     }

            // }
        })

        //console.log(!this.state.contentIds, !notClearedEloIds.length, !this.state.contentIds.length)


        let conceptNames = []
        this.props.selectedItem.concepts.forEach(concept => conceptNames.push(concept.title))

        if (!this.state.contentIds.length && !notClearedEloIds.length) {
            return;
        }

        let payload = {
            contentIds: this.state.contentIds,
            class: this.selectedItem.class,
            section: this.selectedItem.section ? this.selectedItem.section : "",
            chapterTitle: this.selectedItem.chapterName,
            conceptNames: conceptNames,
            notClearedEloIds,
            topWrongPercentage: this.state.topWrongPercentage,
            eloNotClearedStudentPercentageHashByEloId
        }

        // console.log(payload)

        SchoolApi.generatePdf(payload).then(response => {
            // console.log(response)
            this.setState({ pdfReportDownloadLink: response.data.webLink })
        }).catch(err => {
            console.log(err)
        })

    }

    base64ToArrayBufferAkash = (data) => {
        var bString = window.atob(data);
        var bLength = bString.length;
        var bytes = new Uint8Array(bLength);
        for (var i = 0; i < bLength; i++) {
            var ascii = bString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    };

    getWrongAnswers() {
        if (this.props.type == "TEST" || this.selectedItem.type == 'TEST') {
            this.getTestWrongAnswer()
        } else {
            this.getHomeworkWrongAnswer()
        }
    }

    getHomeworkWrongAnswer(payload = {}) {

        if (this.selectedItem) {
            payload.homeworkId = this.selectedItem._id
        }

        if (this.props.from === 'CLICKER_PRACTICE_STANDARD') {
            payload.type = 'CLICKER_PRACTICE_STANDARD'
        }


        HomeworkApi.getHomeworkWrongAnswersReport(payload)
            .then(response => {

                console.log("response", response)
                let wrongAnswersHash = {}
                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                //console.log(result)
                //let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }

                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers
                        result[i].questionCount = questionsArray1.length

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }



                }



                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });


                console.log('wrong hash', wrongAnswersHash)
                console.log('unique', unique)



                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => {
                    filterHash[ele] = ele
                })

                let topQuestions = []

                unique.forEach(item => {
                    topQuestions.push(...item.allQuestionsArray)
                })

                let topFiveWrongAnsweredQuestions = topQuestions.slice(0, 5)

                console.log('top', unique)

                let contentIds = []

                topFiveWrongAnsweredQuestions.forEach(question => contentIds.push(question._id.toString()))

                let topWrongPercentage = unique && unique.length ? unique[0].percentage : 0

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash, topFiveWrongAnsweredQuestions,
                    contentIds,
                    topWrongPercentage
                }, () => {

                })



            }).catch(err => {
                console.log(err)
            })
    }


    getTestWrongAnswer(payload = {}) {

        if (this.selectedItem) {
            payload.testId = this.selectedItem._id
        }
        if (this.props.usersId) {
            payload.usersId = this.props.usersId
        }

        TestApi.getTestWrongAnswersReport(payload)
            .then(response => {

                console.log("response", response)
                let wrongAnswersHash = {}

                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                console.log(result)


                let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }

                }



                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });






                // console.log(wrongAnswersHash)
                console.log(unique)


                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => filterHash[ele] = ele)

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash
                })

            }).catch(err => {
            })
    }

    getStatusWiseWrongAnswers = () => {

        if (this.props.type == "TEST") {
            this.getTestWrongAnswer()
        } else {
            this.getHomeworkStatusWiseWrongAnswers()
        }
    }
    getHomeworkStatusWiseWrongAnswers(payload = {}) {
        console.log(this.props.selectedStatus)
        if (this.props.selectedStatus) {
            payload.status = this.props.selectedStatus
            payload.userIds = this.props.userIds
            payload.homeworkId = this.props.homeworkId
        }

        HomeworkApi.getHomeworkStatusWrongAnswersReport(payload)
            .then(response => {

                let wrongAnswersHash = {}
                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                //  console.log(result)
                // let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }

                }



                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });









                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => filterHash[ele] = ele)

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash
                })

            }).catch(err => {
            })
    }

    getEloReport(payload = {}) {
        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem._id
        }

        if (this.props.from === 'CLICKER_PRACTICE_STANDARD') {
            payload.type = 'CLICKER_PRACTICE_STANDARD'
        }

        this.setState({ isLoading: true })

        HomeworkApi.getEloReport(payload)
            .then(response => {

                console.log(response)

                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                // for (let i = 0; i < localSkillList.length; i++) {
                //     let skill = localSkillList[i]
                //     let detail = skillBaseReport[skill.type.toLowerCase()]
                //     if (!detail) continue
                //     skill.mastered = detail.correct || 0
                //     skill.correctUsers = detail.correctUsers || []
                //     skill.incorrectUsers = detail.incorrectUsers || []
                //     skill.needImprovement = detail.incorrect
                //     let total = detail.correct + detail.incorrect
                //     skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                //     skill.needImprovementPercentage = 100 - skill.masteredPercentage
                //     result.push(skill)
                // }

                let conceptWiseReport = response.conceptBaseReport

                let conceptWiseTopFiveNotClearedElo = []

                for (let i = 0; i < conceptWiseReport.length; i++) {
                    let concept = conceptWiseReport[i]
                    let allSkills = {}
                    let eloLimit = 0

                    for (let j = 0; j < localSkillList.length; j++) {
                        let skill = localSkillList[j]
                        let detail = concept.skill[skill.type.toLowerCase()]
                        if (!detail) continue

                        let notClearedEloList = []

                        for (let k = 0; k < detail.length; k++) {
                            let elo = detail[k]
                            if (elo.incorrect) {
                                if (eloLimit === 5) continue
                                eloLimit += 1
                                notClearedEloList.push(elo)
                            }
                        }

                        if (!allSkills[skill.type.toLowerCase()]) {
                            allSkills[skill.type.toLowerCase()] = [...notClearedEloList]
                        } else {
                            allSkills[skill.type.toLowerCase()].push(notClearedEloList)
                        }

                    }
                    conceptWiseTopFiveNotClearedElo.push({ conceptName: concept.conceptName, skill: allSkills })

                }


                this.setState({
                    skillWiseReport: result,
                    eloReport: response.topFiveNotClearedEloAcrossConcept,
                    totalUsers: response.totalUsers, isLoading: false
                }, () => {
                    setTimeout(() => {
                        this.generatePdf(this.state.eloReport)
                    }, 1000)

                })

            }).catch(err => {

                this.setState({ isLoading: false })
            })
    }

    getHomeworkEvaluationReport(payload = {}) {

        // if (payload.page) payload.page = 1
        // if (payload.page) payload.limit = this.limit
        // payload.type = this.props.type

        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getHomeworkEvaluationReport(payload)
            .then(response => {

                this.setState(
                    {
                        noviceStudents: response.noviceStudents,
                        proficientStudents: response.proficientStudents,
                        advancedStudents: response.advancedStudents,
                        notCompletedStudents: response.notCompletedStudents,
                        isLoading: false
                    })

            }).catch(err => {
            })
    }


    createElementFromHTML = (html) => {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content.firstChild;
    }

    getCanvasSize(coordinates = []) {
        if (!coordinates) return {}
        let maxHeight = 0, maxWidth = 0
        for (let i = 0; i < coordinates.length; i++) {
            for (let j = 0; j < coordinates[i].points.length; j++) {
                if (maxWidth < coordinates[i].points[j].x) {
                    maxWidth = coordinates[i].points[j].x
                }
                if (maxHeight < coordinates[i].points[j].y) {
                    maxHeight = coordinates[i].points[j].y
                }
            }
        }
        return { maxHeight, maxWidth }
    }

    getBlankOptionValueDropDown(content) {

        let styles = {
            p: { fontSize: '23px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        if (content && content.items && content.items.length) {
            let correctItem = content.items.filter((item) => item.isCorrect);
            let correctAnswer = correctItem[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");
            if (correctItem[0].content) {
                return <CwContentViewer content={correctAnswer} />
            } else {
                return <></>
            }
        }
        return <></>
    }

    getJsxForBlankTypeDropDown(option, index) {

        console.log(option, index, this.state.selectedDropDownIndex, this.props.isReadOnly)

        console.log(this.state.actionSheet)

        let styles = {
            p: { fontSize: '19px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        return (
            <div className="position-relative" style={{}}>

                {this.state.selectedDropDownIndex === index ?
                    <>
                        <div className="row mb-2 mt-2 mr-0 ml-0" style={{}}>

                            <div className="blank-wrapper padding-for-dropdown">
                                <div className="dropdown-input">
                                    <div className="d-inline-block alphabet-option ml-2 mr-2">
                                        <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                    </div>
                                    {/* <img className="option-separator-2" src={getThemeImageSource(ImageConstants.OPTION_SEPARATOR, this.props.categoryThemeId)} /> */}
                                    <div className="d-inline-block ml-2" style={{}}>
                                        {
                                            option.selectedText ?
                                                this.parser.parseWithStyles(`${option.selectedText.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
                                                : <span className="cw-input-for-dropdown" style={{}}>
                                                    {"Select One"}</span>
                                        }
                                    </div>

                                    <div className="float-right mt-2" style={{}}>
                                        <img className="dropdown-arrow-size" src={getImageSource(ImageConstants.DROPDOWN_ARROW_BLACK)} />
                                    </div>
                                </div>

                            </div>


                            {/* </LinearGradient> */}
                        </div>
                        {/* {this.state.actionSheet && <ActionSheet modal={this.state.actionSheet} toggleActionSheet={this.toggleActionSheet} options={this.state.dropDownData} onSelect={this.onSelect} categoryThemeId={this.props.categoryThemeId}></ActionSheet>} */}

                    </>


                    :
                    // <LinearGradient colors={Colors.appTheme.gradient1} start={{ x: 0, y: 0 }} end={{ x: 0, y: 1.2 }} style={styles.linearGradiendCard}>
                    <div className="row  mb-2 mt-2 mr-0 ml-0 cursor-pointer" style={{}}>

                        <div className="blank-wrapper padding-for-dropdown">
                            <div className="dropdown-input">
                                <div className="d-inline-block alphabet-option ml-2 mr-2">
                                    <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                </div>
                                <img className="option-separator-2" src={getImageSource(ImageConstants.OPTION_SEPARATOR)} />
                                {
                                    // !this.props.isReadOnly ?
                                    //     <div className="d-inline-block ml-2" style={{}}>
                                    //         {
                                    //             option.selectedText ?
                                    //                 this.parser.parseWithStyles(`${option.selectedText.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
                                    //                 : <span className="cw-input-for-dropdown" style={{}}>
                                    //                     {"Select One"}</span>
                                    //         }
                                    //     </div>
                                    //     :
                                    <div className="d-inline-block ml-2" style={{}}>
                                        {this.getBlankOptionValueDropDown(option)}
                                    </div>
                                }

                                <div className="float-right mt-2" style={{}}>
                                    {/* <img className="dropdown-arrow-size" src={getImageSource(ImageConstants.ARROW_DOWN_ANGLE)} /> */}
                                </div>
                            </div>

                        </div>


                        {/* </LinearGradient> */}
                    </div>
                }

            </div>

        )
    }

    getBlankOptionValue = (content) => {

        let styles = {
            p: { fontSize: '20px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        if (content && content.items && content.items.length) {
            // let parsedJsx = this.parser.parseWithStyles(`${content.items[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
            return (
                <div className="d-inline-block ml-2">
                    <CwContentViewer content={content.items[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")} />
                </div>
            )
        }
        return <></>
    }

    getJsxForBlank(option, index) {
        return (
            <div className="">

                <div >
                    {/* <LinearGradient colors={Colors.appTheme.gradient1} start={{ x: 0, y: 0 }} end={{ x: 0, y: 1.2 }} style={styles.blank}> */}

                    <div className="row  mb-2 mt-2 mr-0 ml-0">
                        <div className="blank-wrapper d-flex align-items-center ">
                            <div className="blank-option">
                                <div className="d-inline-block alphabet-option ml-2 mr-2">
                                    <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                </div>

                                <img className="option-separator" src={getImageSource(ImageConstants.OPTION_SEPARATOR)} />

                                {
                                    this.getBlankOptionValue(option)

                                }

                            </div>

                            {/* <TouchableOpacity onPress={() => this.textInput[index].focus()} style={styles.keyboard} >
                                <Image source={getThemeImageSource(ImageConstants.ASSESSMENT_KEYBOARD, this.props.categoryThemeId)} />
                            </TouchableOpacity> */}
                        </div>
                        {/* </LinearGradient> */}
                    </div>
                </div>
            </div >


        )
    }

    getContentUsingContentType(option, style) {

        let content = option.content.replace(/^(<p>(\s|&nbsp;)*<\/p>)*/, "");

        content = content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");

        if (option.contentType == 1) {
            return <CwContentViewer content={content} />
        } else if (option.contentType == 2) {
            return <div className=''>
                <img className='image-option-container' src={option.content} alt="" />
            </div>
        }

    }

    renderReadOnlyItem = (option) => {
        let options = option.items;
        return (
            options.map((option, i) => (
                <div className="group-items d-flex align-items-center justify-content-center position-relative">

                    {option.contentType == 1 ?
                        <div className="">
                            <div className="text-center">{this.getContentUsingContentType(option, 'answer')}</div>
                        </div>
                        :
                        <div className="">
                            <div className="text-center">{this.getContentUsingContentType(option, 'answer')}</div>
                        </div>

                    }
                </div>
            ))
        )
    }


    getContentTypeOptionsForMultiStep(content, questionNo) {
        console.log(content)

        let isMultiStep = content.content.isMultiStep ? content.content.isMultiStep : false

        console.log(content.content)

        if (isMultiStep) {
            return content.content.steps.map((content, index) => (
                <>
                    <div className='row mt-4 mb-4 align-items-center'>
                        <div className='col-1 part-title'>
                            {questionNo + 1} {CommonUtils.getAlphabet(index)}
                        </div>
                        <div className='col part-question'>
                            <CwContentViewer content={content.content.title} />
                        </div>
                    </div>
                    {content.content.images && content.content.images.length ? content.content.images.map((image, imageIndex) =>
                        <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                    )
                        :
                        ""}
                    {this.renderContentType(content.content.type, content)}
                </>
            ))
        }
    }




    renderContentType = (contentType, content) => {

        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-1 '>
                                        <div className='radio-btn'><div className={`${item.isCorrect === true ? 'inner-selected' : ''}`}></div></div>
                                    </div>
                                    <div className='col align-self-center'>
                                        {item.contentTypeName == 'TEXT' ?
                                            // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                            <CwContentViewer content={item.content} />
                                            :
                                            <div className=''>
                                                <img className='image-option-container' src={item.content} alt="" />
                                            </div>
                                        }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 2:
                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2 '>
                                        <div className='check-box'> {item.isCorrect === true ? <img className="tick-mark-size" src={getImageSource(ImageConstants.TICK_MARK_ICON)} /> : <></>}</div>
                                    </div>
                                    <div className='col'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 3:

                return (
                    <div>
                        <div className='margin-for-options'>
                            {
                                content.content.options && content.content.options.length && content.content.options.map((option, index) => (
                                    <React.Fragment key={'fillInTheBlank' + index}>
                                        {option.contentType == 3 ?
                                            this.getJsxForBlank(option, index)
                                            : this.getJsxForBlankTypeDropDown(option, index)
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                )

            case 4:
                return (

                    <div className='margin-for-options'>
                        <div className='row m-0 p-0'>
                            {content.content.options.map((item, index) =>
                                <div className='col-4 matching-option'>
                                    {item.question.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.question.content} alt="" />
                                        </div>
                                    }
                                    <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
                                    {item.answer.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.answer.content} alt="" />
                                        </div>
                                    }
                                </div>
                            )}

                        </div>
                    </div>

                )

            case 5:

                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col '>{item.contentTypeName == 'TEXT' ?
                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div className='margin-for-options'>
                        {/* <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-2'> {item.contentTypeName == 'TEXT' ?
                                    // <div className='group-items' dangerouslySetInnerHTML={{ __html: item.content }} />
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div> */}
                        <div className="matching-question-container d-flex flex-row mt-4">
                            {content.content.options.map((option, index) => (
                                <div key={"dropZone" + index} className="drop-zone">
                                    <div className="text-center p-1 drop-zone-title">
                                        <CwContentViewer content={option.title} />
                                    </div>
                                    <div className="d-flex flex-row answer-wrapper justify-content-center">
                                        {
                                            this.renderReadOnlyItem(option)
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )

            case 10:
                if (content && content.content && content.content.canvas && content.content.canvas.render && content.content.canvas.render.script && content.content.canvas.render.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        <CanvasPreview id={Math.random()} coordinates={payload || []} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                    )
                }

            default:
                return (<div className='text-center'><b>COMING SOON</b></div>)
        }

    }

    onClickPercentage = (item, index) => {

        // console.log(item)
        // console.log(index)
        // console.log(this.state.selectedIndex)

        if (index == this.state.selectedIndex) {
            this.setState({ selectedPercentage: '', wrongAnswers: this.state.wrongAnswersOfallUsers, selectedIndex: -1, showStudents: false })
        } else {
            this.setState({
                selectedPercentage: item.value, selectedIndex: index, reload: false,
                // wrongAnswers: (this.state.wrongAnswersHash[item.value] ? this.state.wrongAnswersHash[item.value] : []), showStudents: false
            }, () => {
                this.setState({ reload: true })
            })
        }
    }

    viewStudents = (item, index) => {
        console.log(index)
        this.setState({ showStudents: true, students: item.allUsers, viewStudentIndex: index })
        // alert('test')
    }

    // closeStudents = () => {
    //     this.setState({ showStudents: false, students: [] })
    // }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    onClickNotCompleted = () => {
        this.setState({ showNotCompletedList: true })
    }

    closeStudents() {
        this.setState({ showNotCompletedList: false })
    }



    renderBreadcrumb = () => {

        if (!this.props.selectedStatus) {
            return (
                <div className='breadcrumb-1 bg-color'>
                    <span>{`${this.selectedItem.class || ""} >`}</span>
                    <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                    <span className='pl-2'>{this.props.selectedItem.chapter} {`>`}</span>
                    <span className=' pl-2'>{this.getDate(this.selectedItem.createdDate)}</span>
                </div>
            )
        } else {
            return (
                <div className='breadcrumb-1 bg-color'>
                    <span>{this.selectedItem.class || ""}</span>
                    <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                    <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span>
                </div>
            )
        }



    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    showAnswers(index) {

        if (this.state.selectedQuestionIndex === index) {
            this.setState({ showCorrectAnswer: false, selectedQuestionIndex: -1 })
        } else {
            this.setState({ showCorrectAnswer: true, selectedQuestionIndex: index })
        }



    }

    hideAnswers = () => {
        this.setState({ showAnswers: false })
    }

    showSolvedExample(eloDetail, eloIndex, levelIndex) {
        console.log(eloDetail)

        let selectedElo = {
            chapterTitle: this.props.selectedItem.chapter,
            selectedClass: this.selectedItem.class,
            ...eloDetail
        }
        this.setState({
            showSolvedExample: true,
            selectedElo: selectedElo,
            selectedEloIndex: eloIndex,
            selectedLevelIndex: levelIndex
        })

    }

    backHandler = () => {

        let id = this.state.selectedElo.eloId

        this.setState({ showSolvedExample: false }, () => {
            const element = document.getElementById(id);
            console.log(id, element)
            element.scrollIntoView({ behavior: "instant", block: 'center' })

        })
    }

    showLearningOutcomeVideoModal = (eloDetail) => {

        let showVideoList = this.state.showVideoList;

        showVideoList[0] = true


        this.setState({
            showLearningOutcomeVideoModal: true,
            // selectedConceptName: concept.title,
            selectedEloVideoDetails: eloDetail,
            videoLearningContentLength: eloDetail.videoLearningContents.length,
            showVideoList,
            selectedVideoIndex: 0,
            showVideoDetail: false,
        })
    }


    onPageSelected = (selectedPage, startIndex) => {

        console.log(selectedPage, startIndex)

        let currentIndex = selectedPage - 1

        let showVideoList = this.state.showVideoList;
        this.state.selectedEloVideoDetails.videoLearningContents.forEach((videoContent, idx) => {
            if (idx !== currentIndex) {
                showVideoList[idx] = false
            }
        })

        showVideoList[currentIndex] = showVideoList[currentIndex] ? false : true

        this.setState({ showVideoList, selectedVideoIndex: currentIndex, showVideoDetail: false })



        // let payload = {
        //     page: selectedPage,
        // }
        // this.startIndex = startIndex
        // this.filter.page = selectedPage
        // this.setState({ selectedPage, selectedItemIndex: null, selectedItemGroupIndex: null })
        // this.getHomeworkList(this.filter)
    }



    hideLearningOutcomeVideoModal() {
        this.setState({ showLearningOutcomeVideoModal: false })
    }

    showVideoDetail() {
        this.setState({ showVideoDetail: !this.state.showVideoDetail })
    }


    renderEloReportTableBody(elo) {

        let arr = []
        if (elo.skill == "modelling") elo.skill = "modeling"
        let skills = elo.skill
        for (let index = 0; index < this.orderedSkills.length; index++) {
            let key = this.orderedSkills[index]
            let skillDetails = skills[key]

            console.log(skillDetails, key)

            if (!skillDetails) continue

            if (skillDetails && skillDetails.length) {


                arr.push(<tr className='d-flex'>
                    <td className='col-3 table-row-text-for-concept text-center '>{elo.conceptName}</td>
                    <td className='col table-row-text '>
                        {skillDetails.map(item => (
                            <div className='elo-margin mt-1'>{item.title}</div>
                        ))}
                    </td>
                    <td className="col-2 text-center text-for-skill">

                        {`Level ${index + 1}`}

                    </td>
                    <td className="col-2 text-center">

                        <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} /><b className="pl-1 text-for-skill">{key.toUpperCase()}</b>

                    </td>

                </tr>)



                // for (let i = 0; i < skillDetails.length; i++) {
                //     let item = skillDetails[i]
                //     console.log(item.title)
                //     arr.push(
                //         <>
                //             <td className="pl-5">
                //                 <div>{item.title}</div>
                //             </td>
                //             <td className="skill-title pl-5" colSpan="4">
                //                 <span>
                //                     <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} />
                //                 </span>
                //             </td>
                //         </>
                //     )
                // }
            }

        }
        return arr
    }

    renderEloList(elo) {

        let arr = []
        if (elo.skill == "modelling") elo.skill = "modeling"
        let skills = elo.skill
        for (let index = 0; index < this.orderedSkills.length; index++) {
            let key = this.orderedSkills[index]
            let skillDetails = skills[key]

            console.log(skillDetails, key)

            if (!skillDetails) continue

            if (skillDetails && skillDetails.length) {


                arr.push(<div className=''>
                    <div className='table-row-text '>
                        {skillDetails.map(item => (
                            <div id={item.eloId} className='row row-max-width mb-3 align-items-center'>
                                <div className="col-1 text-center pl-0 pr-0">
                                    <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} />
                                </div>
                                <div className='col elo-title pl-0'>
                                    {item.title}
                                </div>
                                {item.videoLearningContents?.length ?
                                    <div className="watch-video-text cursor-pointer mr-3" onClick={() => this.showLearningOutcomeVideoModal(item)}>
                                        <img className="video-icon mr-1" src={getImageSource(ImageConstants.PLAY_ICON_BLUE_BG)} data-tip={"Watch Video"} />
                                        {/* Watch Video */}
                                    </div> : <></>}

                                {item.solvedExampleLearningContents?.length ?
                                    <div className="watch-video-text cursor-pointer " onClick={() => this.showSolvedExample(item, 0, 0)}>
                                        <img className="video-icon mr-1" src={getImageSource(ImageConstants.SOLVED_EXAMPLE_ICON)} data-tip={"Solved Example"} />
                                        {/* Solved Example */}
                                    </div> : ''}
                            </div>
                        ))}
                    </div>
                </div>)
            }

        }
        return arr
    }

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }


    renderEloReport() {

        let eloList = this.state.eloReport?.length ? this.state.eloReport : []
        console.log(eloList)

        return (
            <div className="elo-list-wrapper">
                {/* <div className="table-title ml-4">LEARNING OUTCOMES</div> */}
                {/* {
                    eloList.length ?

                        eloList.map(item => (
                            <div className='p-3 pl-0'>
                                {this.state.reload ?
                                    this.renderEloList(item)
                                    : ""
                                }
                            </div>
                        ))
                        : ""
                } */}
                {
                    eloList.length ?

                        eloList.map(item => (
                            <div className='p-2 pl-0'>
                                <div className=''>
                                    <div className='table-row-text '>

                                        <div id={item.eloId} className='row row-max-width  align-items-center'>
                                            <div className="col-1 text-center pl-0 pr-0">
                                                <img className="skill-img" src={getImageSource(ImageConstants[item.skill.toUpperCase()])} />
                                            </div>
                                            <div className='col elo-title pl-0'>
                                                {item.title}{` (${this.calculatePercentage(item.incorrect, this.state.totalUsers) || 0} %)`}
                                            </div>
                                            {item.videoLearningContents?.length ?
                                                <div className="watch-video-text cursor-pointer mr-3" onClick={() => this.showLearningOutcomeVideoModal(item)}>
                                                    <img className="video-icon mr-1" src={getImageSource(ImageConstants.PLAY_ICON_BLUE_BG)} data-tip={"Watch Video"} />
                                                    {/* Watch Video */}
                                                </div> : <></>}

                                            {item.solvedExampleLearningContents?.length ?
                                                <div className="watch-video-text cursor-pointer " onClick={() => this.showSolvedExample(item, 0, 0)}>
                                                    <img className="video-icon mr-1" src={getImageSource(ImageConstants.SOLVED_EXAMPLE_ICON)} data-tip={"Solved Example"} />
                                                    {/* Solved Example */}
                                                </div> : ''}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))
                        : ""
                }
            </div>
        )
    }

    renderStudentCard() {
        return (
            <div className='evaluation-students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {this.state.notCompletedStudents?.length ? this.state.notCompletedStudents?.map((item, index) =>
                    <div className='px-4 py-2 row align-items-center'>
                        <div className="profile-avatar text-center mr-2 d-inline-block">
                            <div className="row justify-content-center">
                                {item.image ? <img className="" alt="img" src={`${item.basePath}${item.image}`} />
                                    :
                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                            </div>
                        </div>
                        <div className='student-name ml-2'>
                            {item.name}
                        </div>
                    </div>

                )
                    :
                    <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }

    renderHomeworkEvaluationReport() {
        return (
            <div className='homework-evaluation-report-1'>
                <div className='divider-border'></div>
                <div className="text-right pt-4 mr-4 position-relative">
                    <span className="text-danger  cursor-pointer" onClick={this.onClickNotCompleted}><FontAwesomeIcon icon={faTimesCircle} /> Not Completed <span className="not-completed text-primary">{this.state?.notCompletedStudents?.length || 0} Students</span></span>
                    {this.state.showNotCompletedList ? this.renderStudentCard() : ""}
                </div>
                <div className='pt-2 report-card-wrapper ml-3'>
                    <div className={`report-card novice-border ${(this.state.noviceStudents && this.state.noviceStudents.length) ||
                        (this.state.proficientStudents && this.state.proficientStudents.length) ||
                        (this.state.advancedStudents && this.state.advancedStudents.length) > 10 ? 'report-card-height' : ''}`}>
                        <div className='report-card-header' style={{ backgroundColor: '#8B8BF6' }}>
                            <div className='row header-items'>
                                <div className='col-7 text-center'>
                                    <span><span className='header-title'>Novice</span> | <strong>{'< 50 %'}</strong></span>
                                </div>
                                {/* {this.state.noviceStudents && this.state.noviceStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('NOVICE', this.state.noviceStudents)} />
                                    </div>
                                        :
                                        <></>} */}
                            </div>
                        </div>

                        <div className={`report-card-body ${(this.state.noviceStudents && this.state.noviceStudents.length) ||
                            (this.state.proficientStudents && this.state.proficientStudents.length) ||
                            (this.state.advancedStudents && this.state.advancedStudents.length) > 10 ? 'report-card-height' : ''}`}>

                            {this.state.noviceStudents && this.state.noviceStudents.length ? this.state.noviceStudents.map((user, index) => (
                                <div className='row mt-4'>
                                    <div className='col-2 pr-0 my-auto'>
                                        <div className='user-image'>
                                            {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                :
                                                <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                        </div>
                                    </div>
                                    <div className='col my-auto cursor-pointer' >
                                        <span className='user-name'>{user.name}</span>
                                        <span className=" marks pl-2">( Marks: {user.mark}%)</span>
                                        {/* <img className="right-arrow  pt-1" src={getImageSource(ImageConstants.RIGHT_ARROW_GRAY1)} /> */}

                                    </div>
                                </div>
                            ))
                                :

                                <div className="no-data text-center">
                                    <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                    <div className="empty">This is Empty</div>
                                    <div className="no-student">No Student in this bucket</div>
                                </div>
                            }

                        </div>
                    </div>
                    <div className={`report-card proficient-border ${(this.state.noviceStudents && this.state.noviceStudents.length) ||
                        (this.state.proficientStudents && this.state.proficientStudents.length) ||
                        (this.state.advancedStudents && this.state.advancedStudents.length) > 10 ? 'report-card-height' : ''}`}>
                        <div className='report-card-header' style={{ backgroundColor: "#FFBB7C" }}>
                            <div className='row header-items'>
                                <div className='col-7 text-center'>
                                    <span><span className='header-title'>Proficient</span> | <strong>{'50%-80%'}</strong></span>
                                </div>
                                {/* {this.state.proficientStudents && this.state.proficientStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('PROFICIENT', this.state.proficientStudents)} />
                                    </div>
                                        :
                                        <></>} */}
                            </div>
                        </div>

                        <div className={`report-card-body ${(this.state.noviceStudents && this.state.noviceStudents.length) ||
                            (this.state.proficientStudents && this.state.proficientStudents.length) ||
                            (this.state.advancedStudents && this.state.advancedStudents.length) > 10 ? 'report-card-height' : ''}`}>

                            {this.state.proficientStudents && this.state.proficientStudents.length ? this.state.proficientStudents.map((user, index) => (
                                <div className='row mt-4'>
                                    <div className='col-2 pr-0 my-auto'>
                                        <div className='user-image'>
                                            {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                :
                                                <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                        </div>
                                    </div>
                                    <div className='col my-auto cursor-pointer' >
                                        <span className='user-name'>{user.name}</span>
                                        <span className=" marks pl-2">( Marks: {user.mark}%)</span>
                                        {/* <img className="right-arrow  pt-1" src={getImageSource(ImageConstants.RIGHT_ARROW_GRAY1)} /> */}
                                    </div>
                                </div>
                            ))
                                :

                                <div className="no-data text-center">
                                    <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                    <div className="empty">This is Empty</div>
                                    <div className="no-student">No Student in this bucket</div>
                                </div>
                            }

                        </div>
                    </div>
                    <div className={`report-card advance-border ${(this.state.noviceStudents && this.state.noviceStudents.length) ||
                        (this.state.proficientStudents && this.state.proficientStudents.length) ||
                        (this.state.advancedStudents && this.state.advancedStudents.length) > 10 ? 'report-card-height' : ''}`}>
                        <div className='report-card-header' style={{ backgroundColor: "#80D2F4" }}>
                            <div className='row header-items'>
                                <div className='col-7 text-center'>
                                    <span><span className='header-title'>Advance</span> | <strong>{"> 80 %"}</strong></span>
                                </div>
                                {/* {this.state.advancedStudents && this.state.advancedStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('ADVANCE', this.state.advancedStudents)} />

                                    </div>
                                        :
                                        <></>} */}
                            </div>
                        </div>

                        <div className={`report-card-body ${(this.state.noviceStudents && this.state.noviceStudents.length) ||
                            (this.state.proficientStudents && this.state.proficientStudents.length) ||
                            (this.state.advancedStudents && this.state.advancedStudents.length) > 10 ? 'report-card-height' : ''}`}>

                            {this.state.advancedStudents && this.state.advancedStudents.length ? this.state.advancedStudents.map((user, index) => (
                                <div className='row mt-4'>
                                    <div className='col-2 pr-0 my-auto'>
                                        <div className='user-image'>
                                            {/* <img className='user-image' src={'https://countingwell-doubts-assets-dev.s3.ap-south-1.amazonaws.com/366a7097-1ebe-4fc7-9c02-15eb91b53d49-user%20image.png'} /> */}
                                            {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                :
                                                <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                        </div>
                                    </div>
                                    <div className='col my-auto cursor-pointer' >
                                        <span className='user-name'>{user.name}</span>
                                        <span className=" marks pl-2">( Marks: {user.mark}%)</span>
                                        {/* <img className="right-arrow  pt-1" src={getImageSource(ImageConstants.RIGHT_ARROW_GRAY1)} /> */}

                                    </div>
                                </div>

                            ))
                                :
                                <div className="no-data text-center">
                                    <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                    <div className="empty">This is Empty</div>
                                    <div className="no-student">No Student in this bucket</div>
                                </div>
                            }

                        </div>
                    </div>
                    {/* ))} */}
                </div>
            </div>
        )
    }

    renderAnswerOptions() {
        return (
            <Modal className="cw-custom-modal-for-view-answer" isOpen={true} toggle={this.hideAnswers} size={'md'}>

                <ModalBody >
                    <div className="cw-confirm-v2">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.hideAnswers} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>
                        <div className="text-center">
                            <div className="title"><b>Answer</b></div>
                        </div>

                        {/* <Question  /> */}
                        <div className='ml-5'>
                            {this.renderContentType(this.state.selectedQuestionToViewAnswer.content.type, this.state.selectedQuestionToViewAnswer)}
                        </div>



                        <div className="text-center py-4">
                            <button className="cw-button-primary" onClick={this.hideAnswers}>
                                OK
                            </button>
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        )
    }



    showReport(index) {
        let showReport = this.state.showReport
        this.tab.forEach((concept, idx) => {
            if (idx !== index) {
                showReport[idx] = false
            }
        })
        showReport[index] = showReport[index] ? false : true
        console.log(showReport)

        this.setState({ showReport, selectedTabIndex: index })
    }

    downloadReport() {
        let doc = new jsPDF()

        let content = document.getElementById("recommendation-report-pdf-download")





        content.removeAttribute('hidden')


        doc.html(content, {
            callback: function (doc) {
                doc.save();
                content.setAttribute('hidden', true)
            },
            x: 1,
            y: 1,
            autoPaging: true
        })


        // doc.save('output.pdf')

    }

    showDownloadList() {
        this.setState({ showDownloadReportList: true })
    }

    hideDownloadList() {
        this.setState({ showDownloadReportList: false })
    }

    watchLearningOutcomeVideo = () => {
        return (
            <Modal className="cw-custom-modal-for-video" isOpen={true} toggle={this.hideReminderModal} size={'xl'}>
                <ModalBody >
                    <div className="position-relative">
                        <img className="video-detail-polygon" src={getImageSource(ImageConstants.VIDEO_DETAIL_POLYGON)} />
                        <div className="d-flex justify-content-between align-items-center heading ">
                            <div className="d-flex align-items-center">
                                <div className="mr-2">
                                    <img className="book-with-apple" src={getImageSource(ImageConstants.PLAY_ICON_ORANGE)} />
                                </div>
                                <div className="">{this.state.selectedEloVideoDetails.title}<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                            </div>

                            <div className=""><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={() => this.hideLearningOutcomeVideoModal()} /></div>
                        </div>

                        <div className="mb-2">
                            {this.state.selectedEloVideoDetails?.videoLearningContents?.map((videoContent, index) => (
                                <>
                                    {this.state.showVideoList[index] && this.state.selectedVideoIndex === index &&
                                        <>
                                            <div className="row">
                                                <div className="col mb-2"><CwContentViewer from={'video_only'} content={videoContent.content.description} /></div>
                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <div className="read-more-wrapper">
                                                    <span className="read-more cursor-pointer" onClick={() => this.showVideoDetail()}>{`${this.state.showVideoList[index] && this.state.selectedVideoIndex === index && this.state.showVideoDetail == true ? 'Hide More' : 'Read More'}`}</span>
                                                </div>
                                            </div>
                                            {
                                                this.state.showVideoList[index] && this.state.selectedVideoIndex === index && this.state.showVideoDetail == true ?
                                                    <div className="p-4 position-relative">
                                                        <img className="video-detail-header-image" src={getImageSource(ImageConstants.VIDEO_DETAIL_HEADER_IMAGE)} />
                                                        <div className="video-detail-wrapper">
                                                            <div className="elo-title p-4">
                                                                {this.state.selectedEloVideoDetails.title}
                                                            </div>
                                                            <div className="video-detail-divider"></div>
                                                            <div className="pl-4 pr-4">
                                                                <div className="d-flex video-learning-content-wrapper mt-4 mb-4 pb-2">
                                                                    <div className='video-learning-content row '>
                                                                        <div className="col content-alignment mt-2">
                                                                            <div className='d-flex video-learning-content-title'>
                                                                                <div className='mr-1 sr-no '><span className='mt-3 sr-no-bg-color'>{`${index + 1}.`}</span></div>
                                                                                <div className='align-self-center sr-no'>{videoContent.title} </div>
                                                                            </div>
                                                                            <div className="video-content-wrapper">
                                                                                {<CwContentViewer from={'video_content'} content={videoContent.content.description} />}
                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>

                                                    : <></>
                                            }


                                        </>

                                    }
                                </>

                            ))}
                        </div>

                        <div className='card-footer'>
                            {
                                this.state.videoLearningContentLength ?
                                    <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.videoLearningContentLength} onPageSelected={this.onPageSelected.bind(this)} /> : ''
                            }
                        </div>

                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderLearningResourceListCard() {
        return (
            <div className="learning-resource-download-list mt-1">
                <img className="close-icon cursor-pointer float-right" onClick={() => this.hideDownloadList()} src={getImageSource(ImageConstants.CROSS)} />
                <div className="mt-4 mb-4">
                    <div className="d-flex justify-content-start ml-2" >
                        <div>
                            <a className="anchor-tag" download
                                href={this.state.pdfReportDownloadLink} >
                                <img className="download-icon cursor-pointer mr-2" src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)}></img>
                                <span className="download-item">Download</span>
                            </a>
                        </div>
                    </div>
                    {/* <img className="divider-width" src={getImageSource(ImageConstants.LIST_DIVIER)} /> */}

                    {/* <div className="d-flex justify-content-start ml-2">
                        <div>
                            <a className="anchor-tag" href={this.state.cheatSheetPdf} download target='_blank' >
                                <img className="download-icon cursor-pointer mr-2" src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)}></img>
                                <span className="download-item">Cheat Sheet</span>
                            </a>
                        </div>
                    </div> */}

                </div>
            </div>
        )
    }





    render() {

        if (this.state.showSolvedExample) {
            return (
                <SolvedExamples selectedElo={this.state.selectedElo}
                    back={this.backHandler}
                    goToChapterListScreen={() => this.props.back && this.props.back()} />
            )
        }


        return (
            <>
                <div className="classwork-wrong-answers-modal-for-recommendation-report">
                    <div className='item-1' >
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>
                    {/* <div className='cursor-pointer' onClick={() => this.downloadReport()}>Download</div>
                    <div id='recommendation-report-pdf-download' hidden >
                        <div className='test-pdf' style={{ color: 'red', fontSize: '8px' }} >Test Pdf</div>
                       
                    </div> */}
                    <div className='d-flex align-items-center justify-content-between header-report-card'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <img className='circle-image' src={getImageSource(ImageConstants.RECOMMENDATION_REPORT_CIRCLE)} />
                            </div>
                            <div className='ml-2'>
                                <div className=''>
                                    <span className='screen-title-1 title-center'>Remedial Report</span>
                                    <span>{this.renderBreadcrumb()}</span>
                                </div>
                            </div>
                        </div>

                        {
                            this.state.pdfReportDownloadLink ?
                                <div className='position-relative' onMouseEnter={ReactTooltip.rebuild}>
                                    <img className='green-download-icon pt-3 cursor-pointer'
                                        data-tip="Download Report" onClick={() => this.showDownloadList()}
                                        src={getImageSource(ImageConstants.GREEN_DOWNLOAD_ICON)} />
                                    {
                                        this.state.showDownloadReportList ?
                                            this.renderLearningResourceListCard()
                                            :
                                            <></>
                                    }

                                </div>
                                : <></>
                        }



                    </div>





                    <div className='qs-background-color'>
                        <div className='suggestion-text mt-3 mb-3'>
                            {/* Countingwell suggests the following remedy based on the performance of students in the formative assessment. */}
                            {`Implementing the suggested remedial plan will assist the teacher in
resolving misconceptions for nearly ${this.state.topWrongPercentage}% of the students in this class.`}

                        </div>

                        {
                            this.tab.map((tab, tabIndex) => (
                                <>
                                    <div className={`d-flex justify-content-between mt-3 sub-heading cursor-pointer
                                    ${this.state.showReport[tabIndex] ? "border-bottom-radius-none" : ""}`}
                                        style={{ backgroundColor: `${tab.color}` }}
                                        onClick={() => this.showReport(tabIndex)}>
                                        <div className='d-flex align-items-center'>
                                            <div>
                                                <img className='image-size mr-2' src={getImageSource(ImageConstants[`${tab.image}`])} />
                                            </div>

                                            {
                                                tabIndex === 0 ?
                                                    <div className=''>
                                                        <div>{tab.title}{`${this.state.eloReport.length ? ` (Top ` + this.state.eloReport.length + ") ?" : ""}`}</div>
                                                        {/* <div className='sub-title'> {tab.subTitle} </div> */}
                                                    </div>
                                                    :
                                                    tabIndex === 1 ?
                                                        <div className=''>
                                                            <div>{tab.title}{` (Top ${this.state.topFiveWrongAnsweredQuestions.length ? this.state.topFiveWrongAnsweredQuestions.length : ''} Questions to Practice) ?`}</div>
                                                            {/* <div className='sub-title'> {tab.subTitle} </div> */}
                                                        </div>
                                                        :
                                                        tabIndex === 2 ?
                                                            <div className=''>
                                                                <div>{tab.title}</div>
                                                                {/* <div className='sub-title'> {tab.subTitle} </div> */}
                                                            </div>
                                                            :
                                                            ""
                                            }

                                        </div>
                                        <div className='align-self-center'>
                                            <img className='arrow-size'

                                                src={this.state.showReport[tabIndex] ? getImageSource(ImageConstants.ARROW_UP_ANGLE) : getImageSource(ImageConstants.ARROW_DOWN_ANGLE)} ></img>
                                        </div>
                                    </div>
                                    {
                                        this.state.showReport[tabIndex] &&
                                        this.state.selectedTabIndex === 0 &&

                                        <>
                                            {
                                                this.state.topFiveWrongAnsweredQuestions.length ?
                                                    <div className='elo-report-1 p-4'>
                                                        {
                                                            this.renderEloReport()
                                                        }
                                                    </div>

                                                    :

                                                    <div className='text-center mt-3 mb-3'>No Questions</div>


                                            }
                                        </>

                                    }

                                    {
                                        this.state.showReport[tabIndex] &&
                                        this.state.selectedTabIndex === 1 &&
                                        <>
                                            {
                                                this.state.topFiveWrongAnsweredQuestions.length ?
                                                    <div className='question-wrapper pl-4 pr-4 pb-4'>
                                                        <div className='question-container'> {
                                                            this.state.topFiveWrongAnsweredQuestions.map((question, index) => (

                                                                <div div className={`row p-4 mb-3 question-title cursor-pointer
                                                                ${this.state.selectedQuestionIndex === index && this.state.showCorrectAnswer ? "selected-question-bg" : ""}`} onClick={() => this.showAnswers(index)}
                                                                    onMouseEnter={ReactTooltip.rebuild}>
                                                                    <div className='col-1 qs-font-weight'>
                                                                        <div className='circle d-flex justify-content-center align-items-center'>
                                                                            {`${index + 1}`}
                                                                        </div>

                                                                        {/* <span className='qs-subtext-size'>{`${question?.questionPercentage}`}%  Students</span> */}
                                                                    </div>
                                                                    <div className='col qs-line-height pl-1' >
                                                                        <div className='mb-3 wrong-question-title'>
                                                                            <CwContentViewer content={question.content.title} />
                                                                        </div>

                                                                        {question.content.images && question.content.images.length ? question.content.images.map((image, imageIndex) =>
                                                                            <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                                                        )
                                                                            :
                                                                            ""}



                                                                        {
                                                                            this.state.selectedQuestionIndex === index && this.state.showCorrectAnswer ?
                                                                                <div className='mt-4 option-list'>
                                                                                    {/* <div className='divider-line'></div> */}
                                                                                    {question.content.isMultiStep ? this.getContentTypeOptionsForMultiStep(question, index) : this.renderContentType(question.content.type, question)}
                                                                                </div>

                                                                                : <></>

                                                                        }

                                                                        {/* {this.state.showOptions && this.renderContentType(question.content.type, question)} */}
                                                                    </div>

                                                                    <div className='col-1'>
                                                                        <img className='info-icon-size'
                                                                            data-tip={`${question.eloTitle}`}
                                                                            src={getImageSource(ImageConstants.INFO1)} />
                                                                        <img className='arrow-size ml-3 cursor-pointer' src={this.state.selectedQuestionIndex === index && this.state.showCorrectAnswer ? getImageSource(ImageConstants.ARROW_UP_ANGLE) : getImageSource(ImageConstants.ARROW_DOWN_ANGLE)} ></img>
                                                                    </div>

                                                                    {/* <div className='col-1' onClick={() => this.showAnswers(index)}>
                                                                        {this.state.selectedQuestionIndex === index && this.state.showCorrectAnswer ? "Hide Answer" : "View Answer"}
                                                                        
                                                                    </div> */}


                                                                </div>

                                                            ))
                                                        }
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className='text-center mt-3 mb-3'>No Questions</div>
                                            }
                                        </>

                                    }
                                    {
                                        this.state.showReport[tabIndex] &&
                                        this.state.selectedTabIndex === 2 &&
                                        <>
                                            {
                                                this.renderHomeworkEvaluationReport()
                                            }
                                            <div className='text-center mt-3 mb-3 d-flex justify-content-between'>
                                                {
                                                    this.props.from === 'CLICKER_PRACTICE_STANDARD' ? <></>
                                                        :
                                                        <div className='cw-btn-homework d-inline-block cw-btn-primary' onClick={() => this.props.delegate?.props?.delegate?.props?.history.push({ pathname: Path.PERSONALISED_CLASS_WORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}>
                                                            Assign Personalised Schoolwork Sheet
                                                        </div>
                                                }

                                                {/* <div className='cw-btn-homework d-inline-block cw-btn-primary' onClick={() => this.props.delegate?.props?.delegate?.props?.history.push({ pathname: Path.PERSONALISED_CLASS_WORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}>
                                                    Assign Personalised Homework
                                                </div> */}
                                            </div>
                                        </>
                                    }
                                </>
                            ))
                        }




                        {/* <div className='ml-5 mt-4 row'>
                            {this.tab.map((item, index) =>
                                <div className={this.state.selectedIndex == index ? 'selected-percentage-container cursor-pointer' : 'percentage-container cursor-pointer'} onClick={() => this.onClickPercentage(item, index)}>
                                    <div className={this.state.selectedIndex == index ? 'selected-percentage-text' : 'percentage-text'}>{item.title}</div>
                                </div>
                            )}
                            <div className='text-right'>
                                <button className='float-right cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.props.delegate?.props?.delegate?.props?.history.push({ pathname: Path.PERSONALISED_HOMEWORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}>
                                    New Homework
                                </button>
                            </div>


                        </div> */}


                        {/* <div className='text-center p-3 sub-heading'>Top 5 Learning Outcomes to Revise in Class</div> */}

                        {/* {
                            this.state.selectedIndex === 1 ? this.state.topFiveWrongAnsweredQuestions.length ?
                                <div className='elo-report-1'>
                                    {
                                        this.renderEloReport()
                                    }
                                </div>

                                :

                                <div className='text-center mt-3 mb-3'>No Questions</div>

                                : <></>
                        } */}

                        {/* <div className='d-flex justify-content-center align-items-center sub-heading'>
                            <div className='text-center '>Recommended Action</div> */}
                        {/* <div className='text-center'>
                                <button className='cw-btn-lg d-inline-block cw-btn-primary' onClick={() => this.props.delegate?.props?.delegate?.props?.history.push({ pathname: Path.PERSONALISED_HOMEWORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}>
                                    Assign Personalised Homework
                                </button>
                            </div> */}
                        {/* </div> */}



                        {/* {
                            this.renderHomeworkEvaluationReport()
                        }

                        <div className='text-center mt-3 mb-3 d-flex justify-content-between'>
                            <div className='cw-btn-homework d-inline-block cw-btn-primary' onClick={() => this.props.delegate?.props?.delegate?.props?.history.push({ pathname: Path.PERSONALISED_CLASS_WORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}>
                                Assign Personalised Classwork
                            </div>
                            <div className='cw-btn-homework d-inline-block cw-btn-primary' onClick={() => this.props.delegate?.props?.delegate?.props?.history.push({ pathname: Path.PERSONALISED_HOMEWORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}>
                                Assign Personalised Homework
                            </div>
                        </div> */}

                    </div>
                </div >

                {this.state.showAnswers ? this.renderAnswerOptions() : <></>}

                {this.state.showLearningOutcomeVideoModal ? this.watchLearningOutcomeVideo() : ''}

                {/* {
                    this.state.setPublicData ? 
                    
                    
                    <PublicComponent questions = {this.state.topFiveWrongAnsweredQuestions} 
                    setContent = {this.state.setPublicData} /> 
                    : <></>
                } */}

                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true}
                    place='left'
                    type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur" />
            </>
        );
    }
}

export default AddContactComponent;